import { appApiSlice } from "src/api/app-ApiSlice";

export interface ProfileCompletionAnswersRequest {
    responses: {
        question: string;
        answers: string[];
    }[];
}

export interface ProfileCompletionAnswersResponse {
    success: boolean;
}

export const profileCompletionApi = appApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        submitAnswers: builder.mutation<
            ProfileCompletionAnswersResponse,
            { body: ProfileCompletionAnswersRequest; userId?: string }
        >({
            query: ({ body, userId }) => {
                const url = userId ? `v2/profile-completion-form/submit-answers?userId=${encodeURIComponent(userId)}` : `v2/profile-completion-form/submit-answers`;
                return {
                    url,
                    method: "POST",
                    body,
                };
            },
        }),
    }),
});

export const { useSubmitAnswersMutation } = profileCompletionApi;
